export const LIST_SEPARATER = '||*||';



// WEBPACK FOOTER //
// ./src/constant/separator.js